<template>
  <div class="about-content">
    <div class="pb">
      <img src="@/assets/img/PFB.jpg" alt="" />
    </div>

    <div class="bio">
      <h3>Jonas Kunz</h3>

      <p>
        Ich bin leidenschaftlicher Filmemacher.<br> Geboren und aufgewachsen in Bern. Aktueller Wohnsitz in Zürich.<br><br>
        Herzensprojekte von mir gehen von Dokumentarfilmen über Musikvideos bis hin zu Fiktionalfilmen.
        In den letzten Jahren habe ich mit Künstler:innen wie <a href="https://www.instagram.com/julexinfarbe/"
          target="_blank" rel='noopener noreferrer'>Jule X</a>, <a href="https://www.instagram.com/s0ukey/"
          rel='noopener noreferrer' target="_blank">Soukey</a> oder <a href="https://sanmattia.ch/about"
          rel='noopener noreferrer' target="_blank">San Mattia</a> zusammengearbeitet.
        <br><br>
         
        Seit 2025 studiere ich Film an der ZHdK.
      </p>

      <div class="sm-cta">
        <a class="icon" href="mailto:hey@jouns.ch">
          hey@jouns.ch
        </a>
        <a class="icon" href="https://instagram.com/joouuns" target="_blank">
          @joouuns
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.about-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  .pb {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 3vw;

    img {
      height: 20rem;
      border-radius: 20rem;
    }

    p {
      color: #969696;
      font-size: 0.8rem;
    }
  }

  .bio {
    width: 33rem;
    color: #f5f4f3;
    display: flex;
    flex-direction: column;
    align-items: right;

    p {
      text-transform: uppercase;
      margin-top: 0px;

      a {
        font-family: "futura-pt";
      }
    }

    a {
      font-weight: 600;
      text-decoration: underline;
    }
  }

  .sm-cta {
    width: 100%;
    height: 6vh;
    display: flex;
    justify-content: space-between;
    text-align: right;
    align-items: right;

    a {
      text-align: left;

    }

    .icon {
      display: flex;
      justify-content: left;
      align-items: center;
      text-decoration: white underline;

      svg {
        height: 1.8rem;
        padding-right: 0.3rem;
      }

      &:hover {
        text-decoration: #ffee00 underline;
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .about-content {
    padding-top: 12vh;
    height: 88vh;
    flex-direction: column;

    .pb {
      margin-right: 0;

      img {
        height: 45vw;
      }
    }

    .bio {
      text-align: center;
      width: 80vw;
      align-items: center;

      .sm-cta {
        width: 60%;
        justify-content: space-between;

        .icon {
          text-decoration: underline;

          svg {
            width: 8vw;
            padding: 0px;
          }
        }
      }
    }
  }
}
</style>
